import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useBasicSanitationChartsDataContext } from './hooks/useBasicSanitationChartsDataContext';

export const GarbageDestination = () => {
    const { chartData } = useBasicSanitationChartsDataContext();

    return (
        <SimpleBars
            title={'Destino do Lixo'}
            horizontal={false}
            subtitles={
                chartData?.garbageDestination?.map((item) => item.description) || []
            }
            values={chartData?.garbageDestination?.map((item) => item.total  ||  0) || []}
        />
    );
};
